/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MingleService } from '@totvs/mingle';
import { Observable } from '@totvs/mingle/node_modules/rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LiteralsWords } from 'src/app/i18n/literals.model';
import { BranchService } from 'src/app/shared/services/branch/branch.service';
import { SetupSyncService } from 'src/app/shared/services/setup-sync.service';
import { CompanyService } from '../services/company/company.service';
import { LiteralsService } from '../services/literals-service';
import { LoginService } from '../services/login.service';
import { NetworkService } from '../services/network.service';
import { InvoicesService } from '../services/invoices.service';

@Injectable()
export class PGVInterceptor {
  literals: LiteralsWords;
  newReq: any;
  private dialog = false;

  constructor(
    private loginService: LoginService,
    private literalsService: LiteralsService,
    private networkService: NetworkService,
    private companyService: CompanyService,
    private branchService: BranchService,
    private mingleService: MingleService,
    private setupSyncService: SetupSyncService,
    private invoicesService: InvoicesService
  ) {
    this.literals = this.literalsService.getLiteralModule();
  }

  intercept(req: HttpRequest<any>, next: any): Observable<any> {
    this.newReq = req;
    this.setRequestHeader(req);

    return next.handle(this.newReq).pipe(
      catchError(err => {
        const user = localStorage.getItem('user');
        const keepConnected = ['api/pc/v1/invoices'];
        const is401ErrorKeepConnected = keepConnected.some(api => this.newReq?.url?.includes(api));

        if (err instanceof HttpErrorResponse && err.status === 401 && user && !is401ErrorKeepConnected) {
          this.loginService.setExpiredToken(true);
          this.loginService.authOk.next(false);
          localStorage.removeItem('user');
        }

        if (is401ErrorKeepConnected && err.status === 401) {
          this.invoicesService.is401 = true;
          this.invoicesService.msgError = err?.error?.message;
          this.invoicesService.descError = err?.error?.detailedMessage;
        }

        return throwError(() => new HttpErrorResponse(err));
      })
    );
  }

  getCompanyAndBranch(): Array<string> {
    let companyStorage = this.companyService.getCompanyFromStorage();
    let branchStorage = this.branchService.getBranchFromStorage();
    const params = this.mingleService.getParams();

    if (params) {
      companyStorage = companyStorage === 'undefined' ? undefined : companyStorage;
      branchStorage = branchStorage === 'undefined' ? undefined : branchStorage;

      const companyMingle = params.filter(e => e.key.toUpperCase() === 'EMPRESA').map(e => e.value)[0];
      const branchMingle = params.filter(e => e.key.toUpperCase() === 'FILIAL').map(e => e.value)[0];

      if (!companyStorage && !branchStorage) {
        this.setupSyncService.changeCompanyAndBranch(companyMingle, branchMingle);
        if (!companyMingle || !branchMingle) {
          return undefined;
        }
        return [companyMingle, branchMingle];
      } else if (companyStorage === companyMingle && branchStorage === branchMingle) {
        companyStorage = companyMingle;
        branchStorage = branchMingle;
        this.setupSyncService.changeCompanyAndBranch(companyStorage, branchStorage);

        return [companyStorage, branchStorage];
      } else {
        this.setupSyncService.changeCompanyAndBranch(companyStorage, branchStorage);

        return [companyStorage, branchStorage];
      }
    }

    return ['', ''];
  }

  setRequestHeader(req: any): void {
    const params = this.getCompanyAndBranch();
    if (params[0] && params[1]) {
      this.newReq = req.clone({
        headers: req.headers.set('tenantId', `${params[0]},${params[1]}`)
      });
    }
  }

  logout(): void {
    this.dialog = false;
    this.loginService.logoutAuth();
  }

  setOffline(): void {
    this.dialog = false;
    this.networkService.setConnectionToOffline(true);
  }
}
